import React from 'react'
import { Link } from 'react-router-dom';

import { AccountsData } from './Components/AccountData'
import { LastTransactionData, MyCard } from './Components/LastTransactionData'
import { creditDebitChart } from './Components/AccountOverviewChart';
import { invoicesData } from './Components/InvoicesData';
import Chart from "react-apexcharts";
import CountUp from 'react-countup';

const Accounts = () => {
    return (
        <div>
            {/* x---------------------------------x Accounts Card Section x---------------------------------x */}
            <div className="row g-3">
                {AccountsData.map((data, index) => {
                    return (
                        <div className="col-lg-3 col-md-6" key={index}>
                            <div className="card border-0 bg-transparent h-100">
                                <div className="card-body rounded-4 mb-sm-0 bg-white">
                                    <div className="d-flex">
                                        <div
                                            className={`card-img avatar lg no-thumbnail rounded-circle me-3  ${data.icon_bg}`}>
                                            {data.icon}
                                        </div>
                                        <div className="card-text">
                                            <p className="text-secondary opacity-50 fs-6 fw-normal  m-0">{data.title}
                                            </p>
                                            <p className="text-dark fs-6 fw-semibold  m-0">${data.amount}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            {/* x---------------------------------x Last Transaction / MyCards Section x---------------------------------x */}
            <div className="row mt-1 mt-sm-3 g-sm-3 g-1 align-items-stretch">
                {/* x---------------------------------x Last Transaction x---------------------------------x */}
                <div className="col-md-12 col-xl-8 ">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header">
                            <h3 className="text-dark fs-5 fw-semibold ">Last Transaction</h3>
                        </div>
                        <div className="card-body rounded-4 bg-white">
                            <ul className="row g-2 list-unstyled mb-0" id="MyClients">
                                {LastTransactionData.map((data, index) => (
                                    <li className="col-12" key={index}>
                                        <div className="bg-card p-3 rounded-4">
                                            <div className="row g-3 align-items-center">
                                                {/* Transaction Info */}
                                                <div className="col-lg-4 col-md-12">
                                                    <div className="d-flex gap-3 align-items-center">
                                                        <div className={`avatar lg no-thumbnail rounded-circle ${data.icon_bg}`}>
                                                            {data.icon}
                                                        </div>
                                                        <div>
                                                            <p className="mb-1 fw-bold">{data.transactionTitle}</p>
                                                            <span className="text-muted">{data.transactionDate}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Transaction Details */}
                                                <div className="col-lg-8 col-md-12">
                                                    <ul className="list-unstyled row row-cols-2 row-cols-md-4 justify-content-end text-start text-md-end align-items-sm-center mb-0">
                                                        <li>
                                                            <h6>{data.transactionType}</h6>
                                                        </li>
                                                        <li>
                                                            <h6>{data.cardNumber}</h6>
                                                        </li>
                                                        <li>
                                                            <h6>{data.PaymentStatus}</h6>
                                                        </li>
                                                        <li>
                                                            <h6 className={data.text_color}>{data.accountAmount}</h6>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* x---------------------------------x MyCards Section x---------------------------------x */}
                <div className="col-lg-6 col-md-12 col-xl-4">
                    <div className="card border-0 bg-transparent  w-100 h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">My Cards</h3>
                            <Link to="/" className="text-primary text-end fs-5 fw-semibold ">See All</Link>
                        </div>
                        {MyCard.map((myCard, index) => {
                            return (
                                <div className="rounded-4 d-flex flex-column bg-primary custom-atm h-100" key={index}>
                                    <div className="card-body  rounded-4">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h5 className="card-title text-white fs-6 fw-normal font-family-Lato">
                                                    Balance</h5>
                                                <span
                                                    className={`${myCard.text_color} card-text fs-3 fw-normal font-family-Lato`}
                                                >
                                                    $ <CountUp end={myCard.value} duration={2.5} start={0} />
                                                </span>
                                            </div>
                                            <div>
                                                <div className="card-img">
                                                    {myCard.cardIcon}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-4">
                                            <div>
                                                <h5 className="text-white text- fs-6 fw-normal font-family-Lato">CARD
                                                    HOLDER</h5>
                                                <h4 className="card-text text-white fs-3 fw-normal font-family-Lato">
                                                    {myCard.name}</h4>
                                            </div>
                                            <div>
                                                <h5
                                                    className="text-white text-opacity-75 fs-6 fw-normal font-family-Lato">
                                                    VALID THRU</h5>
                                                <h4 className="card-text text-white fs-3 fw-normal font-family-Lato">
                                                    {myCard.expiry}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer rounded-bottom-4">
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <div>
                                                <h4 className="card-text text-white fs-3 fw-normal font-family-Lato">
                                                    {myCard.cardNumber}</h4>
                                            </div>
                                            <div>
                                                <div className="card-img">
                                                    {myCard.f_icon}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Debit & Credit Overview/Invoices Sent Section x---------------------------------x */}
            <div className="row mt-3 g-3">
                {/* x---------------------------------x Debit & Credit Overview x---------------------------------x */}
                <div className="col-xl-8 col-md-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Debit &amp; Credit Overview</h3>
                        </div>
                        <div className="card-body p-0 bg-white rounded-4">
                            <div id="chart-one">
                                <Chart
                                    options={creditDebitChart}
                                    series={creditDebitChart.series}
                                    type={creditDebitChart.chart.type}
                                    height={creditDebitChart.chart.height} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* x---------------------------------x Invoices Sent Section x---------------------------------x */}
                <div className="col-md-4 d-md-none d-xl-block">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Invoices Sent</h3>
                        </div>
                        <div className="card-body bg-white rounded-4 h-100">
                            <div className="d-flex flex-column justify-content-between h-100">
                                {invoicesData.map((data, index) => {
                                    return (
                                        <div className="d-flex justify-content-between my-1" key={index}>
                                            <div className="d-flex">
                                                <div
                                                    className={`no-thumbnail avatar lg rounded-circle me-3 ${data.icon_Bg}`}>
                                                    {data.icon}
                                                </div>
                                                <div>
                                                    <div>
                                                        <p className="text-dark opacity-50 fs-6 fw-medium  m-0">
                                                            {data.heading}</p>
                                                        <p className="text-dark fs-6 fw-normal  m-0">{data.time}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <p className="text-end text-secondary fs-6 fw-normal  m-0">${data.amount}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Accounts